module.exports = __webpack_public_path__ + "TextaNarrow-Heavy-webfont.f55c6d56a5273774e458.eot";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/TextaNarrow-Heavy-webfont.eot
// module id = ../../../../../src-admin/assets/fonts/TextaNarrow-Heavy-webfont.eot
// module chunks = styles